import React from "react";
import PropTypes from "prop-types";
import { Show, useQueryWithStore } from "react-admin";
import CardContentInner from "../../Components/react-admin-components/CardContentInner";
// Material UI
import {
  Tab,
  Tabs,
  Box,
  Typography,
  Grid,
  Avatar,
  Chip,
  makeStyles,
} from "@material-ui/core";

const sanitizeRestProps = ({
  children,
  className,
  record,
  resource,
  basePath,
  version,
  initialValues,
  translate,
  ...rest
}) => rest;

const useStyle = makeStyles({
  header: {
    marginTop: "0.5rem",
    marginLeft: "0.5rem",
  },

  avatar: {
    height: "10rem",
    width: "10rem",
  },

  tabs: {
    marginTop: "1.5rem",
  },
  bold: {
    fontWeight: "bold",
  },
  chip: {
    marginLeft: 5,
    color: "#fff",
  },
});

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
};

const PersonalDetails = ({ record }) => {
  const classes = useStyle();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <div>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}>
          <Typography variant="body2" className={classes.bold}>
            Name
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2"> {record.name}</Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}>
          <Typography variant="body2" className={classes.bold}>
            Gender
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2"> {record.gender}</Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}>
          <Typography variant="body2" className={classes.bold}>
            Is User Opted-In
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2"> {record.OptIn ? "TRUE":"FALSE"}</Typography>
        </Grid>
      </Grid>
   
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}>
          <Typography variant="body2" className={classes.bold}>
            Date of Birth
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2">
            {record.dateOfBirth
              ? month[record.dateOfBirth.substring(3, 2)] +
                " " +
                record.dateOfBirth.substring(8) +
                ", " +
                record.dateOfBirth.substring(0, 4)
              : ""}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

const Address = ({ record }) => {
  const classes = useStyle();
  return (
    <div>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}>
          <Typography variant="body2" className={classes.bold}>
            Communication Address
          </Typography>
        </Grid>
        {record.addressLine1 ? (
          <Grid item xs={10}>
            <Typography variant="body2"> {record.addressLine1}, </Typography>
          </Grid>
        ) : null}
      </Grid>
      {record.addressLine2 ? (
        <Grid container direction="row" spacing={1}>
          <Grid item xs={2}></Grid>
          <Grid item xs={10}>
            <Typography variant="body2"> {record.addressLine2}, </Typography>
          </Grid>
        </Grid>
      ) : null}
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}></Grid>
        <Grid item xs={10}>
          <Typography variant="body2">
            {" "}
            {record.city} {record.state},{" "}
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={2}></Grid>
        <Grid item xs={10}>
          <Typography variant="body2">
            {record.country} - {record.pincode}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

const MentorDetails = ({ record }) => {
  const classes = useStyle();
  const CertificateFileS = useQueryWithStore({
    type: "getList",
    resource: "CertificateFile",
    payload: {
      filter: { mentorId: record.id },
      pagination: { page: 1, perPage: 10 },
      sort: { field: "Category", order: "DSC" },
    },
  });
  return (
    <div>
      {!record.isMentor ? (
        <Typography variant="body2">Not Applied for Mentor</Typography>
      ) : (
        <React.Fragment>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Industry
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {record.industry ? record.industry : " - "}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Certifications
              </Typography>
            </Grid>
            <Grid item xs={10}>
              {typeof record.Certification !== "undefined" ? (
                record.Certification.map((certi) => (
                  <Chip
                    key={certi.index}
                    label={certi}
                    color="primary"
                    className={classes.chip}
                  />
                ))
              ) : (
                <Typography variant="body2"> - </Typography>
              )}
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Description
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">{record.description}</Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Badge
              </Typography>
            </Grid>
            {record.hasOwnProperty("userBadge") ? (
              <>
                <Grid item>
                  <Typography variant="body2">
                    {record.userBadge.attributes.badgeName}
                  </Typography>
                </Grid>
              </>
            ) : null}
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Certificates
              </Typography>
            </Grid>
            {CertificateFileS.loaded && CertificateFileS.data !== undefined && CertificateFileS.data !== null ? (
              <Grid item>
                {CertificateFileS.data.map((doc) => (
                  <a
                    href={doc.certificate._url}
                    download={doc.certificate._url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {doc.certificate._url.split(".").pop() === "pdf" ? (
                      <iframe
                        src={doc.certificate._url}
                        style={{
                          width: "10%",
                          height: "50%",
                          overflowX: "hidden",
                          overflowY: "hidden",
                        }}
                        title="certificate"
                        frameborder="0"
                      ></iframe>
                    ) : (
                      <img
                        src={doc.certificate._url}
                        alt=""
                        style={{
                          width: "10%",
                          height: "50%",
                          float: "left",
                          margin: 5,
                          padding: 2,
                        }}
                      />
                    )}
                  </a>
                ))}
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </React.Fragment>
      )}
    </div>
  );
};

const PricingDetails = ({ record }) => {
  const classes = useStyle();
  return (
    <div>
      {!record.isMentor ? (
        <Typography variant="body2">Not Applied for Mentor</Typography>
      ) : (
        <React.Fragment>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Processing Fee
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {record.processingFee ? record.processingFee : " - "}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={2}>
              <Typography variant="body2" className={classes.bold}>
                Mentor Fee
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography variant="body2">
                {record.mentorFee ? record.mentorFee : " - "}
              </Typography>
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </div>
  );
};
const DetailTabs = ({ record }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes = useStyle();

  return (
    <div>
      <Tabs
        className={classes.tabs}
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Personal Details" />
        <Tab label="Address" />
        <Tab label="Mentor Details" />
        <Tab label="Pricing Details" />
      </Tabs>
      <TabPanel value={value} index={0}>
        <PersonalDetails record={record} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Address record={record} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <MentorDetails record={record} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <PricingDetails record={record} />
      </TabPanel>
    </div>
  );
};

const UserDetailsLayout = ({
  basePath,
  className,
  children,
  record,
  resource,
  version,
  ...rest
}) => {
  const classes = useStyle();
  return (
    <CardContentInner
      className={className}
      key={version}
      {...sanitizeRestProps(rest)}
    >
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        className={classes.header}
      >
        <Grid item md={2}>
          <Avatar
            alt={record.name}
            src={
              record.profileImage !== null && record.profileImage !== undefined
                ? record.profileImage._url
                : " "
            }
            className={classes.avatar}
          />
        </Grid>
        <Grid item md={10}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h4">{record.name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6">
                {record.mobileNo} | {record.email_}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DetailTabs record={record} />
    </CardContentInner>
  );
};

UserDetailsLayout.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  record: PropTypes.object,
  resource: PropTypes.string,
  version: PropTypes.number,
};

//actions={<UserShowActions />}
const UserShow = (props) => (
  <Show title="User Details" {...props}>
    <UserDetailsLayout />
  </Show>
);

export default UserShow;
